import React from "react";
import { ShieldCheck, Truck, RotateCcw, Headphones } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Paiement 100% sécurisé", sub: "Chiffrement SSL 256-bit" },
  { icon: Truck, label: "Livraison offerte", sub: "Dès 60€ FR · 160€ Intl." },
  { icon: RotateCcw, label: "Retours faciles", sub: "14 jours, satisfait ou remboursé" },
  { icon: Headphones, label: "Conciergerie", sub: "7j/7 à votre écoute" },
];

const TrustBadges = () => {
  return (
    <section data-testid="trust-badges" className="py-20 md:py-28 border-y border-white/5 bg-[#080808]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-8">
        {items.map((it, i) => {
          const Icon = it.icon;
          return (
            <div key={it.label} className="text-center reveal" style={{ animationDelay: `${i * 120}ms` }}>
              <Icon size={30} strokeWidth={1} className="mx-auto text-[color:var(--gold)]" />
              <p className="label-caps text-white mt-6 text-[11px]">{it.label}</p>
              <p className="text-xs text-white/45 mt-2 font-light">{it.sub}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TrustBadges;
